import { hot } from 'react-hot-loader';
import { Link } from 'react-router-dom';
import LinkExternal from '../components/Link/LinkExternal';
import {
  facebookUrl, instagramUrl, twitterUrl, discordUrl, openSeaUrl, raribleUrl,
  syaConceptUrl, roobiniumUrl,
} from '../configs';
//import getNftSmartContractUrl from '../hooks/getNftSmartContractUrl';
//import { useEagerConnect, useActiveWeb3React } from '../hooks/index';

import roborovskiSignImg from '../assets/images/roborovski-sign.png';
import './Footer.scss';

//import ReactPixel from 'react-facebook-pixel';


function Footer() {
  //const triedEager = useEagerConnect();
  //const context = useActiveWeb3React();
  //const { chainId } = context;

  return (
    <footer className="footer">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-auto">
            <div className="footer__info">
              <img src={roborovskiSignImg} alt="" title="" className="footer__logo" />
              {/*<div className="footer__author">
                <span>Project created by</span>{" "}
                <LinkExternal href={syaConceptUrl}>SYA Concept</LinkExternal>
              </div>
              <div className="footer__author">
                <span>Webpage created by</span>{" "}
                <LinkExternal href={roobiniumUrl}>roobinium.io</LinkExternal>
              </div>*/}
              <div className="footer__copy">
                © 2022 All rights reserved.
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-auto ml">
            <div className="footer__links">
              <div className="footer__links-title">Docs</div>
              <div className="footer__links-items">
                {/*<Link className="footer__links-item" to="/burn">Burn</Link>*/}
                <Link className="footer__links-item" to="/traits">Traits</Link>
                <Link className="footer__links-item" to="/terms">Terms & Conditions</Link>
                {/*<Link className="footer__links-item" to="/rnct">RNCT Token</Link>
                <Link className="footer__links-item" to="/contracts">Smart Contracts</Link>*/}
                <LinkExternal className="footer__links-item" href="/provenance.html">Provenance Record</LinkExternal>
                <Link className="footer__links-item" to="/ipfs">IPFS Storage</Link>
              </div>
            </div>
          </div>

          <div className="col-6 col-lg-auto">
            <div className="footer__links footer__links--ml13">
              <div className="footer__links-title">Follow</div>
              <div className="footer__links-items">
                {/*<LinkExternal className="footer__links-item" href={facebookUrl}>Facebook</LinkExternal>
                <LinkExternal className="footer__links-item" href={instagramUrl}>Instagram</LinkExternal>*/}
                <LinkExternal className="footer__links-item" href={twitterUrl}>Twitter</LinkExternal>
                {/*<LinkExternal
                  id='joinDiscord'
                  onClick={() => ReactPixel.track('Lead')}
                  className="footer__links-item" href={discordUrl}
                >Discord</LinkExternal>*/}
                <LinkExternal className="footer__links-item" href={openSeaUrl}>OpenSea</LinkExternal>
                {/*<LinkExternal className="footer__links-item" href={raribleUrl}>Rarible</LinkExternal>*/}
              </div>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default hot(module)(Footer);
